import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core';
import { BrokerCreditsPurchasesComponent } from './broker-credits-purchases/broker-credits-purchases.component';
import { BrokerCreditsDealerComponent } from './broker-credits-dealer/broker-credits-dealer.component';
import { BrokerCreditsSalesComponent } from './broker-credits-sales/broker-credits-sales.component';
import { BrokerCreditsManagementComponent } from './broker-credits-management/broker-credits-management.component';
import { CreditCreateComponent } from './credit-create/credit-create.component';
import { CreditsListComponent } from './credits-list/credits-list.component';
import { CreditEditorComponent } from './credit-editor/credit-editor.component';
import { CreditsRoutingModule } from './credits-routing.module';
import { CreditsQuestionsService } from './credits-questions.service';
import { BrokerCreditsDealerService } from './broker-credits-dealer.service';

@NgModule({
  imports: [CommonModule, CoreModule, CreditsRoutingModule],
  declarations: [
    BrokerCreditsDealerComponent,
    BrokerCreditsManagementComponent,
    BrokerCreditsPurchasesComponent,
    BrokerCreditsSalesComponent,
    CreditCreateComponent,
    CreditsListComponent,
    CreditEditorComponent
  ],
  exports: [
    BrokerCreditsPurchasesComponent,
    BrokerCreditsDealerComponent,
    BrokerCreditsSalesComponent,
    BrokerCreditsManagementComponent,
    CreditsListComponent,
    CreditEditorComponent
  ],
  providers: [BrokerCreditsDealerService, CreditsQuestionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CreditsModule {}
